var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iv-message"},[_c('div',{staticClass:"iv-main-width iv-p-t-20"},[_c('Tab',{attrs:{"navList":_vm.navList},on:{"on-click":_vm.tabClick}}),_c(_vm.learnContent,{ref:"learnContent",tag:"component",attrs:{"name":_vm.learnContent},on:{"onloaded":_vm.onloaded}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }